/**
 * COD "Change for" (rider P1f). The customer says which note they will pay with so
 * the rider brings change. Empty means "exact amount / no change needed".
 */
const ARABIC_INDIC = "٠١٢٣٤٥٦٧٨٩";
const PERSIAN = "۰۱۲۳۴۵۶۷۸۹";

function westernDigits(raw: string): string {
  return raw.replace(/[٠-٩۰-۹]/g, (d) => {
    const i = ARABIC_INDIC.indexOf(d);
    return String(i >= 0 ? i : PERSIAN.indexOf(d));
  });
}

export function parseChangeFor(raw: string): number | null {
  const text = westernDigits(raw).trim().replace(/\s+/g, "").replace(/[,٫]/, ".");
  if (!text || !/^\d+(\.\d{1,2})?$/.test(text)) return null;
  return Number(text);
}

export function changeForError(raw: string, amountDue: number): "invalid" | "too_low" | null {
  if (!raw.trim()) return null;
  const value = parseChangeFor(raw);
  if (value === null) return "invalid";
  return value + 1e-9 < amountDue ? "too_low" : null;
}

export function changeForPayload(opts: {
  raw: string;
  isCash: boolean;
  enabled: boolean;
  amountDue: number;
}): { changeFor: number } | Record<string, never> {
  if (!opts.isCash || !opts.enabled) return {};
  const value = parseChangeFor(opts.raw);
  if (value === null || changeForError(opts.raw, opts.amountDue)) return {};
  return { changeFor: value };
}

/** Storefront policy flag (DMS delivery policy via config). Missing means on (fail open). */
export function changeForEnabled(branch: { changeForAtCheckout?: boolean | null } | null | undefined): boolean {
  return branch?.changeForAtCheckout !== false;
}
